import { getWebsiteUrl } from '../config';
import { CTA_BODY, CTA_PRIMARY_LABEL, CTA_SECONDARY_LABEL, CTA_TITLE } from '../trustCopy';
import { TrustKeyTerms } from '../trustKeyTerms';

/**
 * Conversion section: the trust page is where visitors discover ComplyEdge
 * (seal on a product → this page → complyedge.io). One primary ask, one
 * secondary (embed docs). Replaces the old duplicated attribution line.
 */
export function TrustCtaSection() {
  const websiteUrl = getWebsiteUrl();

  return (
    <section className="trust-cta mt-20 lg:mt-24 rounded-2xl border border-primary/25 p-8 text-center md:p-12">
      <h2 className="font-display text-2xl font-bold text-white md:text-3xl">
        <TrustKeyTerms>{CTA_TITLE}</TrustKeyTerms>
      </h2>
      <p className="mx-auto mt-3 max-w-xl text-base leading-relaxed text-gray-300 md:text-lg">
        <TrustKeyTerms>{CTA_BODY}</TrustKeyTerms>
      </p>
      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <a
          href={websiteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 font-display text-sm font-semibold text-dark transition-all hover:brightness-110"
        >
          {CTA_PRIMARY_LABEL}
          <span aria-hidden>→</span>
        </a>
        <a
          href={`${websiteUrl}/docs/trust-badge.html`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center rounded-lg border border-white/15 bg-white/[0.04] px-6 py-3 font-display text-sm font-semibold text-gray-200 transition-colors hover:border-white/30 hover:text-white"
        >
          {CTA_SECONDARY_LABEL}
        </a>
      </div>
    </section>
  );
}
